// Module
var code = `<div class="info-detail">
  <span class="key">Creation type:</span>
  <span class="value">{{ \$ctrl.creationType }}</span>
</div>
<div class="info-detail"
     ng-if="\$ctrl.loan.creationType === 'RESTRUCTURED'">
  <span class="key">Restructured from:</span>
  <span class="value">{{ \$ctrl.restructuredLoanProductNumber }}</span>
</div>
<div class="info-detail"
     ng-if="\$ctrl.loan.creationType === 'RECONSTRUCTED'">
  <span class="key">Reconstructed from:</span>
  <span class="value">{{ \$ctrl.restructuredLoanProductNumber }}</span>
</div>
<div class="info-detail">
  <span class="key">Loan Class:</span>
  <span class="value">{{ \$ctrl.loanClass }}</span>
</div>
<div class="info-detail">
  <span class="key">Loan economic activity:</span>
  <span class="value">{{ \$ctrl.loanEconomicActivity }}</span>
</div>
<div class="info-detail">
  <span class="key">Loan purpose:</span>
  <span class="value">{{ \$ctrl.loanPurpose }}</span>
</div>
<div class="info-detail">
  <span class="key">Loan security:</span>
  <span class="value">{{ \$ctrl.loanSecurity }}</span>
</div>
<div class="info-detail">
  <span class="key">Loan rate type:</span>
  <span class="value">{{ \$ctrl.loanRateType }}</span>
</div>
<div class="info-detail">
  <span class="key">Loan industry purpose:</span>
  <span class="value">{{ \$ctrl.loanIndustryPurpose }}</span>
</div>
<div class="info-detail">
  <span class="key">Loan borrower type:</span>
  <span class="value">{{ \$ctrl.loanBorrowerType }}</span>
</div>
<div class="info-detail">
  <span class="key">Loan transaction type:</span>
  <span class="value">{{ \$ctrl.loanTransactionType }}</span>
</div>
<div class="info-detail">
  <span class="key">MIS group:</span>
  <span class="value">{{ \$ctrl.misGroup }}</span>
</div>
<div class="info-detail">
  <span class="key">CIC contract type:</span>
  <span class="value">{{ \$ctrl.cicContractType }}</span>
</div>
<div class="info-detail">
  <span class="key">Loan microfinance classification:</span>
  <span class="value">{{ \$ctrl.loanMicrofinanceClassification }}</span>
</div>
<div class="info-detail" ng-if="\$ctrl.loan.handoverRequestDate">
  <span class="key">Handover request date:</span>
  <span class="value">{{ \$ctrl.loan.handoverRequestDate | prettyDate }}</span>
</div>
<div class="info-detail" ng-if="\$ctrl.loan.handoverDate">
  <span class="key">Handover date:</span>
  <span class="value">{{ \$ctrl.loan.handoverDate | prettyDate }}</span>
</div>
<div class="info-detail" ng-if="\$ctrl.loan.depEdPolicyNumber">
  <span class="key">DepEd policy number:</span>
  <span class="value">{{ \$ctrl.loan.depEdPolicyNumber }}</span>
</div>
<div class="info-detail"
     ng-if="\$ctrl.customCategories && \$ctrl.customCategories.length > 0"
     ng-repeat="category in \$ctrl.customCategories">
  <span class="key">{{ category.categoryTypeName }}:</span>
  <span class="value">{{ category.categoryName }}</span>
</div>

<table class="table">
  <tr ng-repeat="(key, value) in \$ctrl.files">
    <td>Collateral no. {{ \$index + 1 }}</td>
    <td><a ng-click="\$ctrl.showPreview(value)">Preview file</a></td>
  </tr>
</table>

<zoomable-picture
  ng-show="\$ctrl.previewOn"
  ng-click="\$ctrl.previewOn = false"
  source-url="\$ctrl.currentFile.fileUrl"
  remarks="\$ctrl.currentFile.remarks"
  description="'Collateral security pictures'">
</zoomable-picture>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/loan-account-information/loan-account-information.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;